import { render, staticRenderFns } from "./Glb.vue?vue&type=template&id=35918b16&scoped=true&"
import script from "./Glb.vue?vue&type=script&lang=js&"
export * from "./Glb.vue?vue&type=script&lang=js&"
import style0 from "./Glb.vue?vue&type=style&index=0&id=35918b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35918b16",
  null
  
)

export default component.exports